const VERIFIER_KEY = 'chessplaybook-admin.pkce.verifier';
const STATE_KEY = 'chessplaybook-admin.pkce.state';
const RETURN_KEY = 'chessplaybook-admin.pkce.return';

function base64Url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function randomBytes(length: number): Uint8Array {
  const value = new Uint8Array(length);
  crypto.getRandomValues(value);
  return value;
}

export interface PkceChallenge { verifier: string; challenge: string; state: string }

export async function generatePkce(): Promise<PkceChallenge> {
  const verifier = base64Url(randomBytes(32));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return { verifier, challenge: base64Url(new Uint8Array(digest)), state: base64Url(randomBytes(16)) };
}

export function stashPkce(challenge: PkceChallenge, returnTo: string): void {
  sessionStorage.setItem(VERIFIER_KEY, challenge.verifier);
  sessionStorage.setItem(STATE_KEY, challenge.state);
  sessionStorage.setItem(RETURN_KEY, returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/');
}

export function consumePkce(): { verifier: string; state: string; returnTo: string } | null {
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  const state = sessionStorage.getItem(STATE_KEY);
  const returnTo = sessionStorage.getItem(RETURN_KEY) || '/';
  sessionStorage.removeItem(VERIFIER_KEY);
  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(RETURN_KEY);
  return verifier && state ? { verifier, state, returnTo } : null;
}
